import styled from 'styled-components'
import { mildGray, blue, inputShadow, softGray } from '../../styles/variables'
import { fieldLabel } from '../../styles/common'

const Input = styled.div`
  position: relative;
  padding: 10px 0 20px;
  display: flex;
  flex-direction: column;
  min-width: 250px;

  ${fieldLabel}

  textarea {
    padding: 8px 8px;
    background: white;
    border: none;
    outline: none;
    font-size: 16px;
    flex: 1 1;
    caret-color: ${blue};
    resize: none;
    font-family: inherit;

    &:disabled {
      opacity: 0.5;
    }
  }
`

const InputContainer = styled.div`
  background: white;
  box-shadow: ${inputShadow};
  display: flex;
  flex-direction: row;
  min-height: 34px;
  border: 1px solid white;

  ${({ inverted }) => inverted ? `
    background: ${softGray};
    border: 1px solid ${softGray};
    & > textarea {
      background: ${softGray};
    }
  ` : ''}

  ${({ error }) => error ? `
    border: 1px solid red !important;
  ` : ''}

`

const Icon = styled.div`
  cursor: pointer;
  transition: all .1s ease-in-out;
  color: ${mildGray};
  padding: 4px;
  font-size: 22px;

  &:hover {
    transform: scale(1.1);
    color: black;
    margin-top: 6px
  }
`

const ErrorLabel = styled.label`
  position: absolute;
  bottom: -6px;
  color: red !important;
  margin-top: 4px;
`

export default {
  Input,
  InputContainer,
  Icon,
  ErrorLabel,
}
